var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-checkbox-group',{on:{"change":_vm.changeSetting},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},_vm._l((_vm.currentSettingList),function(item){return _c('el-checkbox',{key:item.id,attrs:{"label":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }